import { userInfoFrag } from '../../../../utils/type/user.common-type';
import { personInfoFrag } from '../../../../utils/type/person.common-type';

export const getFolderByPersonFrag = `
    id
    serviceId
    personId
    person {
        ${personInfoFrag}
    }
`;

export const getWorkDetailFrag = `
    id
    workType
    serviceId
    dateFrom
    dateTo
    folderId
    users {
        ${userInfoFrag}
    }
    workData {
        ... on WorkDataMassWorkObject {
            form
            presence
        }
    }
`;
